import styled from "@emotion/styled";
import { Box, Theme, useMediaQuery } from "@mui/material";
import { toCurrency } from "@helpers";
import { MandatorTypography } from "@rentablo/components";
import { RangeSelectorControlProps } from "@hooks";
import {
  CollapsibleRangeSelector,
  TABLE_INTERVAL_TYPES,
} from "./Chart/ChartControls";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

const Wrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface TableSummaryProps {
  currencySymbol?: string;
  summaryValue: number;
  rangeProps: RangeSelectorControlProps;
  hideMobileRangeSelector?: boolean; //TODO: Remove once all pages use MobilePanel pattern
}

export const TableSummary = ({
  summaryValue = 0,
  currencySymbol,
  rangeProps,
  hideMobileRangeSelector = false,
}: TableSummaryProps) => {
  const isLessSm = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  return (
    <Container>
      <Wrapper>
        <MandatorTypography variant="h4" kpmg-germany={{ variant: "h5" }}>
          {toCurrency(summaryValue, currencySymbol)}
        </MandatorTypography>
        {!isLessSm && (
          <div>
            <CollapsibleRangeSelector
              rangeProps={rangeProps}
              intervalTypes={TABLE_INTERVAL_TYPES}
            />
          </div>
        )}
      </Wrapper>
      {isLessSm && !hideMobileRangeSelector && (
        <CollapsibleRangeSelector
          rangeProps={rangeProps}
          intervalTypes={TABLE_INTERVAL_TYPES}
        />
      )}
    </Container>
  );
};
